// `?v=N` busts browser caches when the underlying asset is replaced —
// public/ files keep a stable URL, so bump the version on every swap.
export const AKEERA_AVATAR_SRC = '/images/akeera-avatar.png?v=2'

/**
 * Where the widget sits: the LAUNCHER is a child of each page's 60px top
 * header, in its end-side action cluster — not a floating overlay. Putra's
 * call (2026-10-15): the header is the one chrome that is on every page and
 * stays put while the page scrolls.
 *
 * The PANEL is `fixed` — it is an overlay — and sits in the bottom-END corner
 * of the viewport, where Putra's 2026-10-16 update put it (before that it hung
 * from the header). `end-6` matches every header's `px-6`, so the card's end
 * edge lines up with the launcher above it; `bottom-6` keeps the same 24px at
 * the foot. Logical `end-*` mirrors in RTL.
 *
 * The px twins feed the panel-size clamp in store/helpAgentSlice.ts — keep
 * them in step with the classes.
 */
export const HELP_PANEL_INSET = 'bottom-6 end-6'
export const HELP_PANEL_END_MARGIN_PX = 24
/** Breathing room kept at the far (start) side: the w-20 rail plus a gutter. */
export const HELP_PANEL_START_OFFSET_PX = 104
/**
 * How far the card may rise: it stops short of the 60px header and the
 * launcher in it, keeping the same 24px gap it keeps at the foot.
 */
export const HELP_PANEL_TOP_CLEARANCE_PX = 84

/**
 * Z-index ladder (documented here, used across the widget):
 * - panel: z-[9980] — above page chrome, deliberately BELOW
 *   InAppMeetingPanel (9999) so an active call pill is never hidden,
 *   and far below Radix dialogs (z-[999999]) so modals always win.
 *   The launcher sits in the header's own flow and needs no z-index.
 * - tour dim/spotlight: z-[9990]; tour tooltip: z-[9991].
 */
export const HELP_WIDGET_Z = 'z-[9980]'
export const TOUR_OVERLAY_Z = 'z-[9990]'
export const TOUR_TOOLTIP_Z = 'z-[9991]'
